<template>

  <b-row v-if="esEndocrino">
    <b-col>
      <b-card
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGIA ENDOCRINOLOGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse v-model="visibleBody" role="tabpanel">
          <b-card-body style="padding: 1.5rem">
            <b-row>
              <b-col>
                <b-form-group>
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Ha experimentado alguno de los siguientes síntomas? (Seleccione todos los que apliquen)
                  </label>
                  
                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="sintomasOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => endocrinologia.sintomas = onAddNewOpt(newArray)"
                  />
                </b-form-group>

                <b-form-group class="my-2" v-if="isVisibleEndocrinoComienzo">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">¿Cuándo comenzaron sus síntomas?</label>
                  
                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="comienzoOpts"
                    :reduce="option => option"
                    label="text"
                    v-model="endocrinologia.comienzo"
                  />

                </b-form-group>

                <b-form-group class="my-2" v-if="isVisibleEndocrinoFactores">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Factores de riesgo?
                  </label>
                  
                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="factoresOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => endocrinologia.factores = onAddNewOpt(newArray)"
                  />

                </b-form-group>

                <b-form-group class="my-2" v-if="isVisibleEndocrinoTratamientos">
                  <hr>
                  <label for="" style="font-size: small;" class="mb-1">
                    ¿Recibe actualmente algún tipo de tratamiento? (Seleccione todos los que apliquen)
                  </label>
                  
                  <v-select
                    placeholder="Seleccione una o mas opciones"
                    :options="tratamientosOpts"
                    :reduce="option => option"
                    label="text"
                    :multiple="true"
                    taggable
                    @input="newArray => endocrinologia.tratamientos = onAddNewOpt(newArray)"
                  />

                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>

import vSelect from 'vue-select'
import { addNewOpt } from '@/shared/helpers';
import { mapState } from 'vuex';

export default {
  name: 'SemiologiaEndocrino',

  components: {
    vSelect
  },

  data() {
    return {
      visibleBody: true,

      endocrinologia: {
        sintomas: [],
        comienzo: null,
        factores: [],
        tratamientos: [],
      },
      isVisibleEndocrinoComienzo: false,
      isVisibleEndocrinoFactores: false,
      isVisibleEndocrinoTratamientos: false,

      sintomasOpts:[
        { value: "fatiga",                text: "Fatiga" },
        { value: "aumentoPeso",           text: "Aumento de peso" },
        { value: "perdidaPeso",           text: "Pérdida de peso" },
        { value: "cambiosApetito",        text: "Cambios en el apetito" },
        { value: "sedExcesiva",           text: "Sed excesiva" },
        { value: "miccionFrecuente",      text: "Micción frecuente" },
        { value: "cambiosPiel",           text: "Cambios en la piel" },
        { value: "perdidaCabello",        text: "Pérdida de cabello" },
        { value: "cambiosCicloMenstrual", text: "Cambios en el ciclo menstrual" },
        { value: "dolorCabeza",           text: "Dolor de cabeza" },
        { value: "palpitaciones",         text: "Palpitaciones" }
      ],

      comienzoOpts:[
        { value: 'dias',    text: 'días' },
        { value: 'semanas', text: 'semanas' },
        { value: 'meses',   text: 'meses' },
        { value: 'anios',   text: 'años' }
      ],

      factoresOpts: [
        { value: "antecedentes_familiares", text: "Antecedentes familiares de enfermedades endocrinas" },
        { value: "obesidad",                text: "Obesidad" },
        { value: "sedentarismo",            text: "Sedentarismo" },
        { value: "dieta_poco_saludable",    text: "Dieta poco saludable" },
        { value: "estres",                  text: "Estrés" },
        { value: "edad_avanzada",           text: "Edad avanzada" },
        { value: "embarazo",                text: "Embarazo" },
        { value: "consumo_alcohol",         text: "Consumo excesivo de alcohol" },
        { value: "fumar",                   text: "Fumar" },
        { value: "exposicion_sustancias",   text: "Exposición a sustancias tóxicas" }
      ],

      tratamientosOpts: [
        { value: "medicamentos_orales",  text: "Medicamentos orales" },
        { value: "inyecciones_insulina", text: "Inyecciones de insulina" },
        { value: "terapia_hormonal",     text: "Terapia hormonal" },
        { value: "cambios_dieta",        text: "Cambios en la dieta" },
        { value: "ejercicio_fisico",     text: "Ejercicio físico" },
        { value: "cirugia",              text: "Cirugía" }
      ]

    };
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },

    onAddNewOpt( newValue ){
      return addNewOpt( newValue );
    }
  },
  
  computed:{
    ...mapState({
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esEndocrino(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000520';
    },

  },

  watch: {
    endocrinologia: {
      handler(newValue) {
        this.isVisibleEndocrinoComienzo     = newValue.sintomas.length > 0;
        this.isVisibleEndocrinoFactores     = newValue.comienzo && this.isVisibleEndocrinoComienzo;
        this.isVisibleEndocrinoTratamientos = newValue.factores.length > 0 && this.isVisibleEndocrinoFactores;
      },
      deep: true,
    },
  },

};
</script>

